import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import httpClient from "../util/HttpClient";

const contentPageStyles = {
  minHeight: "100vh",
  background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
  padding: "48px 24px",
  boxSizing: "border-box",
};

const containerStyles = {
  maxWidth: "720px",
  margin: "0 auto",
  textAlign: "center",
};

const titleStyles = {
  color: "#e8e8e8",
  fontSize: "2rem",
  fontWeight: 700,
  marginBottom: "32px",
  letterSpacing: "0.02em",
};

const contentWrapperStyles = {
  background: "rgba(255, 255, 255, 0.06)",
  borderRadius: "12px",
  padding: "32px 40px",
  border: "1px solid rgba(255, 255, 255, 0.08)",
  textAlign: "left",
};

const contentStyles = {
  color: "#d0d0d0",
  fontSize: "1rem",
  lineHeight: 1.7,
};

const loadingStyles = {
  color: "#a0a0a0",
  fontSize: "1.125rem",
};

const errorStyles = {
  color: "#e57373",
  fontSize: "1.125rem",
};

function ContentPages() {
  const { key: pageName } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pageName) {
      setLoading(false);
      setError("Page not specified");
      return;
    }

    setLoading(true);
    setError(null);

    httpClient
      .get("/pages")
      .then((res) => {
        const data = res.data;
        const list = Array.isArray(data) ? data : (data?.data ?? []);
        const found = list.find(
          (p) =>
            p.pageName && p.pageName.toLowerCase() === pageName.toLowerCase(),
        );
        if (found) {
          setPage(found);
        } else {
          setError("Page not found");
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message || "Failed to load page");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [pageName]);

  if (loading) {
    return (
      <div style={contentPageStyles}>
        <div style={containerStyles}>
          <p style={loadingStyles}>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={contentPageStyles}>
        <div style={containerStyles}>
          <p style={errorStyles}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={contentPageStyles}>
      <style>{`
        .content-page-body h2 { color: #e8e8e8; font-size: 1.25rem; margin: 1.5em 0 0.5em; }
        .content-page-body p { margin: 0 0 1em; }
        .content-page-body ul { margin: 0.5em 0 1em; padding-left: 1.5em; list-style-position: inside; }
        .content-page-body li { margin: 0.25em 0; }
      `}</style>
      <div style={containerStyles}>
        <h1 style={titleStyles}>{page?.title}</h1>
        <div style={contentWrapperStyles}>
          <div
            style={contentStyles}
            className="content-page-body"
            dangerouslySetInnerHTML={{ __html: page?.content ?? "" }}
          />
        </div>
      </div>
    </div>
  );
}

export default ContentPages;
